import React from 'react';
import UserImage from '@/components/UserImage';
import s from './Workflow.module.scss';

type Props = {
  initiatedBy: {
    color: string;
    id: string;
    logo: string;
    name: string;
  };
};

const InitiatedByPill = ({ initiatedBy }: Props): JSX.Element => (
  <div className={s.initiatedByPill}>
    <UserImage size={14} url={initiatedBy.logo} name={initiatedBy.name} />
    <div className="caption">{initiatedBy.name}</div>
  </div>
);
export default InitiatedByPill;
